<template>
  <b-card no-body class="my-1 noborder-card" v-show="showProduct">
    <b-card-header header-tag="header" class="p-1 pb-1" role="tab">
      <order-checkbox
        v-on:addproduct="addProduct(productData)"
        :wasChecked="
          isAlreadyChecked &&
          !(
            (type === 'module' || type === 'add') &&
            accountantAdd &&
            !accountant
          )
        "
        :isChecked="inCart"
        :product="productData"
        :styles="styles"
        :text="label"
        :fontBold="clientOwns && type === 'module' && accountantAdd"
      >
      </order-checkbox>
      <span
        v-if="type === 'module' || type === 'add' || type === 'skp'"
        v-b-toggle="type + '-' + product.key"
      >
        <span class="when-closed px-2">
          <i class="fas fa-chevron-down"></i
        ></span>
        <span class="when-open px-2"
          ><i class="fas fa-chevron-up when-open"></i
        ></span>
      </span>
      <b-form-input
        v-if="product.key === 'O' && inCart"
        name="oNumber"
        class="number-box"
        size="sm"
        min="1"
        v-model="quantity"
        type="number"
      ></b-form-input>
      <span
        class="ml-3"
        :class="{ 'float-right': type !== 'skp', 'mr-3': type !== 'skp' }"
      >
        <span
          v-if="productData && productData.OLD_NETTO && productData.NETTO >= 0"
        >
          <span class="text-danger line-through px-2">
            {{ commaFormat(productData.OLD_NETTO) }} zł
          </span>
        </span>
        <span
          v-if="
            productData &&
            (!isAlreadyChecked ||
              ((type === 'module' || type === 'add') && accountantAdd)) &&
            productData.NETTO >= 0
          "
          >{{ commaFormat(productData.NETTO) }} zł</span
        >

        <span
          class="small"
          v-if="productData && productData.OLD_NETTO && productData.NETTO >= 0"
        >
          (Najniższa cena z 30 dni przed obniżką:
          <span v-if="productData.OMNIBUS_NETTO">{{
            productData.OMNIBUS_NETTO
          }}</span>
          <span else>{{ productData.OLD_NETTO }}</span> zł)
        </span>
      </span>
    </b-card-header>
    <b-collapse
      :id="type + '-' + product.key"
      :accordion="accordionId"
      role="tabpanel"
    >
      <b-card-body>
        <b-card-text v-html="descriptionModified"></b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderCheckbox from './OrderCheckbox';

export default {
  name: 'ProductRow',
  components: { OrderCheckbox },
  props: {
    styles: {},
    product: { type: Object },
    productData: { type: Object },
    accordionId: { type: String },
    type: { type: String },
    isAccountant: { type: Boolean, default: false },
    skpAdd: { default: null },
    accountantAdd: { type: Boolean },
    unpaidOrder: { default: null },
    hideWhenOwned: { default: false },
  },
  data() {
    return {
      checked: false,
    };
  },
  created() {
    if (this.showProduct) {
      this.$emit('showProductsElements', this.type);
    }
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      client: 'auth/client',
      isInCart: 'order/isInCartProducts',
      cartProducts: 'order/getCartProducts',
      totalProducts: 'order/totalProducts',
      getQuantity: 'order/quantity',
    }),
    showProduct() {
      return !(
        this.hideWhenOwned &&
        this.isAlreadyChecked &&
        !(
          (this.type === 'module' || this.type === 'add') &&
          this.accountantAdd &&
          !this.accountant
        )
      );
    },
    accountant() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('B')
      );
    },
    productDataMutable() {
      return this.productData;
    },
    quantity: {
      get() {
        return this.getQuantity;
      },
      set(value) {
        this.productDataMutable.quantity = value;
        this.$store.commit('order/setQuantity', value);
        this.$store.commit('order/removeProduct', this.productDataMutable);
        this.$store.commit('order/addProduct', this.productDataMutable);
      },
    },
    clientOwns() {
      return (
        (this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes(this.product.key) &&
          !this.skpAdd) ||
        (this.client.DOD !== null &&
          this.client.DOD !== '' &&
          this.client.DOD.split('').includes(this.product.key))
      );
    },
    isAlreadyChecked() {
      if (this.skpAdd && (this.type === 'module' || this.type === 'add')) {
        return false;
      }

      if (
        this.product.key === 'F' &&
        !this.isAccountant &&
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('M')
      ) {
        return true;
      }

      return this.clientOwns;

      // if (this.type === 'add') {
      //   return this.client.DOD.split('').includes(this.product.key);
      // }
      //
      // return this.client.MDS.split('').includes(this.product.key);
    },
    inCart() {
      return this.isInCart(this.productDataMutable);
    },
    descriptionModified() {
      if (this.product.key === 'X' && !this.isAccountant) {
        return (
          'Umożliwia przekazanie do innego programu SKP wskazanej partii danych księgowych. ' +
          '<br>Możliwa jest konfiguracja typu:' +
          '<ul><li>jedna kopia programu znajduje się np. w sklepie lub zakładzie, gdzie wystawiane są faktury</li>' +
          '<li>druga kopia zainstalowana jest np. w biurze lub w domu, gdzie przeprowadzana jest pełna obróbka księgowa firmy</li>' +
          '<li>okresowo (np. codziennie, raz w tygodniu lub w miesiącu) ze stanowiska sprzedaży eksportowane są dane dotyczące sprzedaży (na CD, pendrive bądź plik wysłany mailem, itp.). Dane te wczytywane są na drugim stanowisku.</li></ul>' +
          'Wymiana danych jest możliwa między egzemplarzami programu o tym samym numerze licencji i tej samej wersji.'
        );
      }
      if (this.product.key === 'X' && this.isAccountant) {
        return (
          'Dodatek dla użytkowników SKP<sup>®</sup> w wersji dla biur bądź wersji wielostanowiskowej, ' +
          'który pozwala na odciążenie biura od czasochłonnej czynności wprowadzania dużej ilości dokumentów sprzedaży. ' +
          'Jeżeli klient biura posiada wersję ograniczoną lub wersję z dodatkiem Wymiana Danych, ' +
          'może sporządzać okresowo (np. raz w miesiącu) zestawienie dokumentów sprzedaży i przekazywać je za ' +
          'pośrednictwem Internetu lub na nośniku zewnętrznym do biura. Biuro, posiadające dodatek Wymiana Danych po ' +
          'wczytaniu tych danych, uzyskuje zapisy księgowe dotyczące sprzedaży i może zająć się pozostałymi księgowaniami ' +
          'oraz sporządzaniem wymaganych zestawień i raportów. Wymiana danych jest możliwa między egzemplarzami ' +
          'programu SKP<sup>®</sup> o dowolnych numerach licencji.'
        );
      }

      if (this.product.key === 'J' && this.isAccountant) {
        return (
          'Dodatkowo płatny dodatek umożliwiający łączenie utworzonego w programie SKP<sup>®</sup> pliku JPK_V7M, JPK_V7K ' +
          'z takim samym plikiem pochodzącym z innego programu, a zawierającym np. sprzedaż danego miesiąca. ' +
          'Warunkiem jest to, by importowany plik był zgodny ze schematem Ministerstwa Finansów w zakresie Jednolitych ' +
          'Plików Kontrolnych. <br><br>Opcja szczególnie przydatna w przypadku biur rachunkowych, które do tej pory księgowały ' +
          'sprzedaż klienta fakturującego w innym systemie, jednym wpisem na podstawie otrzymanego rejestru VAT lub firm ' +
          'posiadających oddziały, w których każda jednostka wystawia faktury sprzedażowe i tworzy osobne rejestry VAT, ' +
          'natomiast deklaracja VAT sporządzona jest jedna łącznie dla całej firmy. <br><br>Pliki z różnych źródeł są poddawane ' +
          'kontroli i scalane w jeden JPK_V7M, JPK_V7K, który następnie wystarczy tylko podpisać i wysyłać elektronicznie.<br>' +
          '<br><strong>Co więcej?</strong><br><ul>' +
          '<li>dzięki funkcji FA ->VAT można w prosty i łatwy sposób zmienić plik JPK_FA na JPK_V7M, JPK_V7K</li>' +
          '<li>weryfikacja plików względem poprawności logicznej związanej ze strukturą pliku JPK_V7M, JPK_V7K oraz kontrola zawartości pliku jako listy dokumentów sprzedaży i zakupów</li></ul>' +
          '    <br><strong class="color-green">Nowość!</strong> <br/>Dodatkowa funkcjonalność, która <strong>przyspieszy\n' +
          '        księgowanie</strong> w Twojej firmie, dzięki możliwości <strong>importu dokumentów do zakładki\n' +
          '        Księgowanie</strong> z plików w strukturze JPK_FA, JPK_VAT, JPK_PKPIR. <br/>Możliwa jest również zmiana pliku\n' +
          '    JPK_FA na JPK_V7M, JPK_V7K.<br/>\n' +
          '    <a href="https://www.ksiega-podatkowa.pl/akademia-skp/import-dokumentow-z-plikow-jpk-do-skp" target="_blank">Więcej o funkcji importu ></a>'
        );
      }

      if (this.product.key === 'J' && !this.isAccountant) {
        return (
          'Dodatkowo płatny moduł umożliwiający łączenie utworzonego w programie SKP pliku JPK_V7M/7K z takim samym plikiem pochodzącym z innego systemu, a zawierającym np. sprzedaż danego miesiąca. Warunkiem jest by importowany plik był zgodny ze schematem MF w zakresie pliku  JPK_V7M/7K. Możliwa jest również konwersja pliku JPK_FA na schemat JPK_V przed scaleniem plików.' +
          '<br>Opcja szczególnie przydatna dla firm posiadających oddziały, w których każda jednostka wystawia faktury sprzedażowe i tworzy osobne rejestry VAT, natomiast deklaracja VAT sporządzana jest jedna łącznie dla całej firmy.' +
          '    <br><strong class="color-green">Nowość!</strong> <br/>Dodatkowa funkcjonalność, która <strong>przyspieszy\n' +
          '        księgowanie</strong> w Twoim biurze, dzięki możliwości <strong>importu dokumentów do zakładki\n' +
          '        Księgowanie</strong> z plików w strukturze JPK_FA, JPK_VAT, JPK_PKPIR. <br/>Możliwa jest również zmiana pliku\n' +
          '    JPK_FA na JPK_V7M, JPK_V7K.<br/>\n' +
          '    <a href="https://www.ksiega-podatkowa.pl/akademia-skp/import-dokumentow-z-plikow-jpk-do-skp" target="_blank">Więcej o funkcji importu ></a>'
        );
      }

      return this.product.description;
    },
    hidden() {
      return (
        this.product.key === 'O' &&
        !this.client.DOD.split('').includes('X') &&
        this.cartProducts.filter((item) => item.key === 'X').length === 0
      );
    },
    label() {
      return this.product.ID === 1
        ? 'SKP<sup>®</sup> Start FIRMA - obsługa jednej firmy'
        : this.product.label;
    },
  },
  methods: {
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    addProduct(productData) {
      if (
        this.unpaidOrder &&
        this.unpaidOrder[this.productData.key] &&
        this.unpaidOrder[this.productData.key] > 0
      ) {
        this.$bvModal.msgBoxOk(
          'Dodatek został już zamówiony, oczekuje na płatność. Przejdź do Historii zamówień , odszukaj poprzednie zamówienie i dokonaj płatności.',
          {
            title: '',
            size: 'sm',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
          }
        );

        return;
      }

      if (
        !this.clientOwns ||
        (this.skpAdd && this.type === 'module') ||
        (this.accountantAdd && (this.type === 'module' || this.type === 'add'))
      ) {
        if (this.productData.key === 'M') {
          this.$emit('minimadded', !this.isInCart(productData));
        }

        this.$emit('addproduct', productData);
      }
    },
  },
};
</script>

<style scoped>
.number-box {
  display: inline;
  width: 50px;
}
</style>
